var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.initHasNext || _vm.initHasPrevious
    ? _c("div", { staticClass: "container-fluid mt-5" }, [
        _c(
          "div",
          { staticClass: "col-lg txt_seo mb-4" },
          [_vm._t("seo-text1")],
          2
        ),
        _vm._v(" "),
        _c("nav", [
          _c(
            "ul",
            {
              staticClass:
                "pagination pagination-md pg-blue justify-content-center",
            },
            [
              _vm.initHasPrevious
                ? _c("li", { staticClass: "page-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "page-link",
                        attrs: {
                          "aria-label": "Previous",
                          title: _vm.i18n.previous,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.change(_vm.page - 1)
                          },
                        },
                      },
                      [
                        _vm._t("pagination-left-icon"),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v(_vm._s(_vm.i18n.previous)),
                        ]),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.initHasPrevious
                ? _c("li", { staticClass: "page-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "page-link",
                        attrs: { href: _vm.paginationFirstUrl },
                      },
                      [_vm._v("\n          1\n        ")]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.page - 1 > 1
                ? _c("li", { staticClass: "page-item" }, [
                    _c("span", { staticClass: "page-item" }, [_vm._v("...")]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("li", { staticClass: "page-item disabled" }, [
                _c("a", { staticClass: "page-link" }, [
                  _vm._v("\n          " + _vm._s(_vm.page) + " "),
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v("(" + _vm._s(_vm.i18n.current) + ")"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.initHasNext
                ? _c("li", { staticClass: "page-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "page-link",
                        attrs: { "aria-label": "Next", title: _vm.i18n.next },
                        on: {
                          click: function ($event) {
                            return _vm.change(_vm.page + 1)
                          },
                        },
                      },
                      [
                        _vm._t("pagination-right-icon"),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v(_vm._s(_vm.i18n.next)),
                        ]),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }